import registerElement from './register-element'
import i18n from '@/locales'
export function globalRegister(app) {
  app.use(registerElement)
  app.use(i18n)
}
